<script lang="ts">
    import { mdiContentCopy, mdiDeleteOutline } from "@mdi/js"
    import { createAccountToken, deleteAccountToken, loadAccountTokens } from "../../api"
    import { getTableColumn } from "../../getTableColumns"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import Modal from "../widgets/Modal.svelte"
    import Table from "../widgets/Table.svelte"
    import { newNotification } from "../../store"
    import DateField from "../widgets/fields/DateField.svelte"
    import Icon from "../widgets/Icon.svelte"
    import { _ } from "svelte-i18n"

    let description = ""
    let generatedToken: Partial<AccountToken>
    let gridBreakPoint = 768
    let innerWidth = window.innerWidth
    let reloadTokens = false
    function getAccountTokenButtons() {
        return [
            {
                label: $_("account.deleteToken"),
                className: "btn",
                svgPath: mdiDeleteOutline,
                onClick: (row: Operation | OperationOut) => {
                    deleteAccountToken(row.id).then(() => {
                        reloadTokens = !reloadTokens
                    })
                },
                getTooltip(operation: any) {
                    return {
                        content: $_("account.deleteTokenTooltip"),
                    }
                },
            },
        ]
    }

    const frontendBase = typeof window !== "undefined" ? window.location.origin : ""
    const namespace =
        "renz_einfo" + (typeof window !== "undefined" && window.location.origin.includes("dev") ? "_dev" : "")
</script>

<style lang="less">
    .accountToken:global {
        .btn .label {
            display: inline-block !important;
        }
        form {
            display: flex;
            gap: 1rem;
            button {
                width: 190px;
                text-transform: uppercase;
                font-weight: 700;
                display: flex;
                justify-content: center;
            }

            @media (max-width: 768px) {
                flex-direction: column;
                button {
                    width: 100%;
                }
            }
        }
    }
    .accountTokenDetails {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        .accountTokenHint {
            margin-bottom: 2rem;
        }

        em {
            font-style: normal;
            font-weight: 700;
        }
        p {
            display: flex;
            margin: 0px;
            gap: 1rem;
            em:first-child {
                width: 100px;
            }
            span {
                display: flex;
            }
            @media (max-width: 768px) {
                flex-direction: column;
                em:first-child {
                    width: 100%;
                }
            }
        }
        .copy-btn {
            color: var(--renz-rot);
            width: 15px;
            margin-left: 20px;
        }
    }
</style>

<svelte:window bind:innerWidth />
<section class="accountToken section_padding">
    <div class="container">
        <h1>{$_("account.apiAccountToken")}</h1>
        <h2>{$_("account.createApiToken")}</h2>
        <form
            on:submit|preventDefault|stopPropagation="{() => {
                createAccountToken(description).then((token) => {
                    generatedToken = token
                    reloadTokens = !reloadTokens
                    newNotification({
                        class: 'success',
                        html: $_('general.accessKeyCreated'),
                    })
                })
            }}"
        >
            <input type="text" placeholder="{$_('general.description')}" bind:value="{description}" required />
            <button class="btn primary" type="submit">{$_("account.createToken")}</button>
        </form>

        <h2>{$_("account.existingTokens")}</h2>
        {#key reloadTokens}
            {#await loadAccountTokens()}
                <MiniLoader />
            {:then existingTokens}
                {#if !existingTokens?.length}
                    <p>{$_("account.noApiTokensCreated")}</p>
                {:else}
                    <Table
                        className=""
                        gridview="{innerWidth <= gridBreakPoint}"
                        columns="{getTableColumn(false, 'accountToken')}"
                        buttonsColumn="{{
                            label: $_('general.actions'),
                            className: ' max-w-140 w-70',
                        }}"
                        buttons="{getAccountTokenButtons()}"
                        rows="{existingTokens}"
                    />{/if}
            {/await}{/key}

        {@html $_("account.documentationHTML", { values: { frontendBase, namespace } })}
    </div>
</section>
{#if generatedToken}
    <Modal
        show="{true}"
        on:close="{() => {
            generatedToken = null
        }}"
    >
        <div slot="header">{$_("account.apiAccountToken")}</div>
        <div class="accountTokenDetails">
            <p class="accountTokenHint">
                <em>{$_("account.hint")}:</em>
                <em>{$_("account.saveTokenWarning")}</em>
            </p>
            <p>
                <em>{$_("account.token")}:</em>
                <span
                    >{generatedToken._token}
                    <button
                        class="btn transparent copy-btn"
                        on:click="{() => {
                            navigator.clipboard.writeText(generatedToken._token)
                            newNotification({
                                class: 'success',
                                html: $_('account.tokenCopiedNotification'),
                            })
                        }}"><Icon size="24px" path="{mdiContentCopy}" /></button
                    ></span
                >
            </p>
            <p>
                <em>{$_("account.createdOn")}:</em>
                <span><DateField value="{'insertTime' in generatedToken ? generatedToken.insertTime : ''}" /></span>
            </p>
            <p>
                <em>{$_("account.description")}:</em>
                <span>{"description" in generatedToken ? generatedToken.description : ""}</span>
            </p>
        </div>
    </Modal>
{/if}
